module.exports = __webpack_public_path__ + "img/layers.11a558e9.svg";